import {Icon, Link} from "../styled";
import {MobileMenuWrap} from "./styled";

export const MobileMenu = ({isMenuOpen, setIsMenuOpen, header}) => {
    return (
        <MobileMenuWrap $isMenuOpen={isMenuOpen}>
            {header?.links?.map((link, index) => {
                if (link.href.startsWith('http') || link.href.startsWith('mailto')) {
                    return (
                        <Link key={index} as="a" href={link.href} target={link.href.startsWith('http') ? '_blank' : undefined} rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined} onClick={() => setIsMenuOpen(false)}>
                            {link.className && <Icon width={16} height={17} src={"./icons/login.svg"} />}
                            {link.title.toUpperCase()}
                        </Link>
                    );
                }
                return (
                    <Link key={index} to={link.href} onClick={() => setIsMenuOpen(false)}>
                        {link.className && <Icon width={16} height={17} src={"./icons/login.svg"} />}
                        {link.title.toUpperCase()}
                    </Link>
                );
            })}
        </MobileMenuWrap>
    )
}